import React, { FC } from 'react';
import { FullHeightLoader } from '../../../common';
import styles from './SmartGridLoadingIndicator.scss';

export const SmartGridLoadingIndicator: FC = () => <FullHeightLoader className={styles.indicator} />;
